import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';

const SimpleAutoComplete = ({ options, placeholder, onClickAction, className }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [value, setValue] = useState('');

  const getSuggestions = valueItem => options.filter(option => (option.searchValue || option.display || option).toLowerCase().indexOf(valueItem.toLowerCase()) > -1 && valueItem.length >= 2);

  const onChange = (event, { newValue, method }) => {
    setValue(newValue);
  };

  const inputProps = {
    placeholder,
    value,
    onChange,
    type: 'search',
    className: `form-input ${ className }`,
  };

  const onSuggestionsFetchRequested = useCallback(({ value: newValue }) => setSuggestions(getSuggestions(newValue)), []);

  const onSuggestionsClearRequested = useCallback(() => setSuggestions([]), []);

  const getSuggestionValue = useCallback(suggestion => suggestion.display || suggestion, []);

  const renderSuggestion = useCallback(suggestion => (<span>{ suggestion.display || suggestion }</span>), []);

  const onSuggestionSelected = useCallback((event, { suggestion, suggestionValue, index, method }) => {
    event.preventDefault();
    onClickAction(suggestion);
  }, []);

  return (<Autosuggest
    suggestions={ suggestions }
    onSuggestionsFetchRequested={ onSuggestionsFetchRequested }
    onSuggestionsClearRequested={ onSuggestionsClearRequested }
    getSuggestionValue={ getSuggestionValue }
    renderSuggestion={ renderSuggestion }
    onSuggestionSelected={ onSuggestionSelected }
    inputProps={ inputProps }
  />);
};

SimpleAutoComplete.propTypes = {
  options: PropTypes.instanceOf(Array).isRequired,
  onClickAction: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

SimpleAutoComplete.defaultProps = {
  placeholder: '',
  className: ''
};

export default SimpleAutoComplete;
